const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

export const API_BASE_URL = isLocalhost
  ? "https://dev.beeon.in/api"
  : `${window.location.protocol}//${window.location.host}/api`;

export const FILE_BASE_URL = isLocalhost
  ? ""
  : `${window.location.protocol}//${window.location.host}`;